import * as Icons from "react-icons/fa";

export function getIconFromName(name: string) {
  const IconComponent = Icons["Fa" + name];
  if (IconComponent) {
    return <IconComponent />;
  } else {
    return null;
  }
}
